/**
 * Check if an entertainment has a valid capacity configuration.
 * @param {Object} entertainment - The entertainment object to check
 * @returns {boolean} - True if the entertainment has capacity configuration, false otherwise
 */
export const hasCapacityConfiguration = entertainment => {
  if (!entertainment) return false;

  return !!(
    (entertainment.ltSlotCapacity && entertainment.ltSlotCapacity > 0) ||
    (entertainment.pbSlotCapacity && entertainment.pbSlotCapacity > 0) ||
    (entertainment.laneCount && entertainment.laneCount > 0) ||
    (entertainment.participantLaneDensity && entertainment.participantLaneDensity > 0) ||
    (entertainment.resourceIds && entertainment.resourceIds.length > 0) ||
    (entertainment.orderedResources &&
      Array.isArray(entertainment.orderedResources.resources) &&
      entertainment.orderedResources.resources.length > 0)
  );
};
